import { render, staticRenderFns } from "./RegionMap.vue?vue&type=template&id=115fca78&"
import script from "./RegionMap.vue?vue&type=script&lang=js&"
export * from "./RegionMap.vue?vue&type=script&lang=js&"
import style0 from "./RegionMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports